import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {Redirect} from 'react-router-dom';
import Navbar from 'components/NavbarUnauthenticated/index';
import Spinner from 'components/Spinner';
import {WithLogin} from 'services/auth/WithLogin';
import {WithCheckLoggedIn} from '../../services/auth/WithCheckLoggedIn';
import {WithSelectOrganization} from '../../services/auth/WithSelectOrganization';
import LoginForm from './components/LoginForm';
import {WithChangeLocale} from 'containers/LanguageProvider/WithChangeLocale';


const DEFAULT_REDIRECT = '/o';
const START_PAGE = '/start';

class LoginStatusHandler extends React.Component {
    static propTypes = {
        selectOrganization: PropTypes.func,
        selectedOrganizationId: PropTypes.string,
        isLoggedIn: PropTypes.bool,
        loading: PropTypes.bool,
        applications: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string
        })),
        organizations: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string
        })),
        searchString: PropTypes.string,
        locale: PropTypes.string,
        changeLocale: PropTypes.func,
        user: PropTypes.shape({
            language: PropTypes.string
        })
    };

    componentDidMount() {
        this.selectOrganizationIfOnlyOne();
        this.changeLocaleIfDifferent();
    }

    componentDidUpdate() {
        this.selectOrganizationIfOnlyOne();
        this.changeLocaleIfDifferent();
    }

    selectOrganizationIfOnlyOne = () => {
        if (this.organizationToRedirectTo()) {
            this.props.selectOrganization(this.organizationToRedirectTo());
        }
    };

    changeLocaleIfDifferent = () => {
        if (this.props.isLoggedIn && (this.props.user.language !== this.props.locale)) {
            this.props.changeLocale(this.props.user.language);
        }
    };

    organizationToRedirectTo = () => {
        const acceptedOrganizations = this.props.organizations
            .filter(organization => organization.isAccepted);
        if (this.props.organizations.length === 1
            && acceptedOrganizations.length === 1
            && this.props.applications.length === 0) {
            return this.props.organizations[0].id;
        }
        return false;
    };

    applicationToRedirectTo = () => {
        if (this.props.applications.length === 1 && this.props.organizations.length === 0) {
            return this.props.applications[0].id;
        }
        return false;
    };

    getRedirectUrl = () => {
        const params = queryString.parse(this.props.searchString);
        return params.redirect ? params.redirect : DEFAULT_REDIRECT;
    };

    getPreFilledEmail = () => {
        const params = queryString.parse(this.props.searchString);
        return params.email;
    };

    getMessage = () => {
        const params = queryString.parse(this.props.searchString);
        return params.message;
    };

    render() {
        const {loading, isLoggedIn, selectedOrganizationId} = this.props;

        if (loading) {
            return <Spinner/>;
        }

        if (!isLoggedIn) {
            return (
                <WithLogin redirectUrl={this.getRedirectUrl()}>
                    {(login, loginResult) => (
                        <LoginForm
                            login={login}
                            loginResult={loginResult}
                            preFilledEmail={this.getPreFilledEmail()}
                            message={this.getMessage()}/>
                    )}
                </WithLogin>
            );
        }

        if (isLoggedIn && selectedOrganizationId) {
            return <Redirect to={this.getRedirectUrl()}/>;
        }

        if (this.applicationToRedirectTo()) {
            return <Redirect to={`${START_PAGE}/job-application/${this.applicationToRedirectTo()}`}/>;
        }

        /* This option causes login errors in some scenarios (impersonation, etc.)
        if (this.organizationToRedirectTo()) {
            return <div>Redirecting to organization...</div>;
        }
        */

        return <Redirect to={START_PAGE}/>;
    }
}

class LoginView extends React.Component {
    static propTypes = {
        location: PropTypes.shape({
            search: PropTypes.string
        }).isRequired
    };

    render() {

        return (
            <section className="hero is-fullheight alva-bg">
                <Navbar/>

                <div className="hero-body">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-6 is-offset-2" style={{height: '400px', maxWidth: '450px'}}>

                                <WithCheckLoggedIn>
                                    {({isLoggedIn, selectedOrganizationId, organizations, user, loading, applications, refetchLoginStatus}) => (
                                        <WithChangeLocale>
                                            {({locale, changeLocale}) => (
                                                <WithSelectOrganization onOrganizationSelected={refetchLoginStatus}>
                                                    {({selectOrganization}) => (
                                                        <LoginStatusHandler
                                                            locale={locale}
                                                            changeLocale={changeLocale}
                                                            user={user}
                                                            searchString={this.props.location.search}
                                                            selectedOrganizationId={selectedOrganizationId}
                                                            selectOrganization={selectOrganization}
                                                            loading={loading}
                                                            isLoggedIn={isLoggedIn}
                                                            organizations={organizations}
                                                            applications={applications}/>
                                                    )}
                                                </WithSelectOrganization>
                                            )}
                                        </WithChangeLocale>
                                    )}
                                </WithCheckLoggedIn>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default LoginView;
